package com.solevo.dist.network.firebase.api.quotes

import com.solevo.dist.application.models.Quote
import com.solevo.dist.application.models.QuoteStatus
import com.solevo.dist.application.models.User.Companion.currentCustomerId
import com.solevo.dist.application.models.User.Companion.legalId
import com.solevo.dist.network.api.quotes.QuoteRemoteSource
import com.solevo.dist.network.firebase.api.quotes.models.FirebaseQuote
import com.solevo.dist.network.firebase.api.quotes.models.toQuote
import com.solevo.dist.network.implementation.firebase.FirebaseFields
import com.solevo.dist.network.implementation.firebase.FirestoreCollections
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.mapNotNull

class QuoteFirebaseRemoteSource(
    private val firestore: dev.gitlive.firebase.firestore.FirebaseFirestore = Firebase.firestore
): QuoteRemoteSource {

    override fun getQuotesLive(): Flow<List<Quote>> {
        return firestore.collection(FirestoreCollections.QUOTES_COLLECTION)
            .where { FirebaseFields.CUSTOMER_ID.equalTo(currentCustomerId.value) }
            .where { FirebaseFields.LEGAL_ENTITY_ID.equalTo(legalId) }
            .where { FirebaseFields.STATUS.inArray(listOf(QuoteStatus.Awaiting.name, QuoteStatus.Received.name)) }
            .snapshots
            .mapNotNull { querySnapshot ->
                querySnapshot.documents.map { it.data(FirebaseQuote.serializer()).toQuote() }
            }
    }

    override fun getQuoteDetails(quoteId: String): Flow<Quote?> {
        return firestore.collection(FirestoreCollections.QUOTES_COLLECTION)
            .where { FirebaseFields.CUSTOMER_ID.equalTo(currentCustomerId.value) }
            .where { FirebaseFields.LEGAL_ENTITY_ID.equalTo(legalId) }
            .where { FirebaseFields.QUOTE_ID.equalTo(quoteId) }
            .snapshots
            .map { querySnapshot ->
                if (querySnapshot.documents.isEmpty()) {
                    null
                } else {
                    querySnapshot.documents.map { it.data(FirebaseQuote.serializer()) }.first().toQuote()
                }
            }
    }

    override suspend fun updateQuote(quoteId: String, unread: Boolean): Result<Unit> {
        return runCatching {
            firestore.collection(FirestoreCollections.QUOTES_COLLECTION)
                .where { FirebaseFields.CUSTOMER_ID.equalTo(currentCustomerId.value) }
                .where { FirebaseFields.LEGAL_ENTITY_ID.equalTo(legalId) }
                .where { FirebaseFields.QUOTE_ID.equalTo(quoteId) }
                .snapshots
                .first().documents.first().reference
                .update(mapOf(FirebaseFields.UNREAD to unread))
        }
    }

    suspend fun deleteQuote(quoteId: String): Result<Unit> {
        return runCatching {
            firestore.collection(FirestoreCollections.QUOTES_COLLECTION)
                .where { FirebaseFields.CUSTOMER_ID.equalTo(currentCustomerId.value) }
                .where { FirebaseFields.LEGAL_ENTITY_ID.equalTo(legalId) }
                .where { FirebaseFields.QUOTE_ID.equalTo(quoteId) }
                .snapshots
                .first().documents.first().reference
                .delete()
        }
    }
}


